'use client';

import { useViewport } from '@lib/tools/hooks/useViewport';
import NextImage from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import style from './GallerySlideModalInner.module.scss';
const GallerySlideModalInner = ({
  url,
  scale,
  setScale
}) => {
  const ref = useRef();
  const element = ref?.current?.instance?.contentComponent;
  element?.setAttribute('id', url);
  const {
    viewport,
    isDesktop
  } = useViewport();
  const [allowPanning, setAllowPanning] = useState(true);
  useEffect(() => {
    if (viewport && scale) {
      if (isDesktop) {
        setAllowPanning(false);
      } else if (scale > 1.1) {
        setAllowPanning(false);
      } else setAllowPanning(true);
    }
  }, [viewport, scale]);
  useEffect(() => {
    element?.setAttribute('id', url);
  }, []);
  const getNameForAlt = url_0 => {
    const filenameWithExtension = url_0.slice(url_0.lastIndexOf('/') + 1);
    const filename = filenameWithExtension.split('.')[0];
    return filename;
  };
  return <>
      <TransformWrapper doubleClick={{
      mode: scale > 1.1 ? 'zoomOut' : 'zoomIn'
    }} ref={ref} panning={{
      disabled: allowPanning
    }} onInit={e => setScale(e.state.scale)} onZoomStart={e_0 => setScale(e_0.state.scale)} onZoom={e_1 => setScale(e_1.state.scale)} onZoomStop={e_2 => setScale(e_2.state.scale)}>
        {() => <TransformComponent>
            <span className={style.imgWrapper}>
              <NextImage className={style.img} src={url} alt={getNameForAlt(url)} fill />
            </span>
          </TransformComponent>}
      </TransformWrapper>
    </>;
};
export default GallerySlideModalInner;